import React, { useCallback } from 'react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { useDrawer } from 'ducks/drawers/hooks'
import { CHANNEL_EMAIL_TYPES } from 'subapps/settings/components/drawers/Channels/Channels.data'
import { googleLogo as GoogleLogo } from 'assets/icons/groove'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import { styles } from './styles'

const Footer = ({ className, firstStep = false, onClickCreateBtn }) => {
  const { openDrawer: openEmailDrawer } = useDrawer(
    CHANNEL_EMAIL_TYPES.forwarding.drawer
  )
  const { drawerId, openDrawer: openOAuthDrawer } = useDrawer(
    CHANNEL_EMAIL_TYPES.google.drawer
  )

  const handleCreateEmail = useCallback(
    () => {
      openEmailDrawer('new', {
        additionalProps: {
          firstStep,
          drawerSource: 'inbox',
        },
      })
      if (onClickCreateBtn) {
        onClickCreateBtn()
      }
    },
    [openEmailDrawer, firstStep, onClickCreateBtn]
  )

  const handleCreateOAuth = useCallback(
    () => {
      openOAuthDrawer('new', {
        query: {
          ...buildDrawerQueryParam(drawerId, 'drawerChannelType', 'google'),
        },
        additionalProps: {
          firstStep,
          drawerSource: 'inbox',
        },
      })
      if (onClickCreateBtn) {
        onClickCreateBtn()
      }
    },
    [openOAuthDrawer, drawerId, firstStep, onClickCreateBtn]
  )
  return (
    <div css={styles.footer} className={className}>
      <Button
        css={[styles.btn, styles.oAuthButtton]}
        type="info"
        size="xBig"
        onClick={handleCreateOAuth}
        customIcon={<GoogleLogo />}
      >
        Connect Gmail
      </Button>
      <Button
        type="tertiary"
        size="xBig"
        css={[styles.btn, styles.emailBtn]}
        onClick={handleCreateEmail}
      >
        Add email from another provider
      </Button>
    </div>
  )
}

export default Footer
